import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { SanitizedFeedSectionArticle } from "@typings/Cue";
import { DefaultNavigationData } from "@typings/Page";

export enum AwardType {
  E50 = "events-awards_enterprise-50",
  EE = "events-awards_emerging-enterprise",
  SBA = "events-awards_singapore-business-awards",
  SCA = "events-awards_singapore-corporate-awards",
  SIA = "events-awards_sustainability-impact-awards",
  DATA = "events-awards_design-ai-tech-awards",
}

export type JudgingPanelMember = {
  name: string;
  title: string;
  subtitle?: string;
};

export type EventsAwardsPageContext<
  T extends
    | EventsAwardsPageContextData
    | EventsAwardsLandingPageContextData
    | EventsAwardsWinnersContextData,
> = {
  kind: "section";
  data: T;
};

export type Winner = {
  title?: string;
  recipient?: string | string[][];
  position?: string;
  organization?: string;
  type?: "paragraph" | "table";
};

export type AwardDataRow = {
  awardType?: AwardType;
  blockTitleProps?: {
    text?: string;
    link?: string;
  };
  description?: string;
};

export type EventsAwardsPageContextData = {
  title: string;
  e50Article?: ComponentProps<typeof Card>;
  eeArticle?: ComponentProps<typeof Card>;
  sbaArticle?: ComponentProps<typeof Card>;
  scaArticle?: ComponentProps<typeof Card>;
  siaArticle?: ComponentProps<typeof Card>;
  dataArticle?: ComponentProps<typeof Card>;
} & DefaultNavigationData;

export type EventsAwardsLandingPageContextData = {
  title: string;
  awardType?: string;
  article?: SanitizedFeedSectionArticle;
};

export type EventsAwardsWinnersContextData = {
  title: string;
  awardType: AwardType;
  articles: SanitizedFeedSectionArticle[];
};

export type EventsAwardsGalleryContextData = {
  title: string;
  awardType: AwardType;
  articles: SanitizedFeedSectionArticle[];
  year?: string;
};

export type AwardsMenu = {
  text: string;
  link: string;
  enabled?: boolean;
};

export type EventsAwardsNewsContextData = {
  title: string;
  awardType: AwardType;
  articles: ComponentProps<typeof Card>[];
};

export type EventsAwardsHomePageContextData = {
  title: string;
  awardType?: AwardType;
  articleProps?: ComponentProps<typeof Card>;
};

export type EventsAwardsNavLogoProps = {
  logo: string;
  widthDesktop: number;
  widthMobile: number;
};

export enum AwardNameType {
  "events-awards_enterprise-50" = "Enterprise 50",
  "events-awards_emerging-enterprise" = "Emerging Enterprise",
  "events-awards_singapore-business-awards" = "Singapore Business Awards",
  "events-awards_singapore-corporate-awards" = "Singapore Corporate Awards",
  "events-awards_sustainability-impact-awards" = "Sustainability Impact Awards",
  "events-awards_design-ai-tech-awards" = "Design AI Tech Awards",
}
